import { render } from "./MemberApplicationTabDataPekerjaan.vue?vue&type=template&id=072d7c04&scoped=true"
import script from "./MemberApplicationTabDataPekerjaan.vue?vue&type=script&lang=js"
export * from "./MemberApplicationTabDataPekerjaan.vue?vue&type=script&lang=js"

import "./MemberApplicationTabDataPekerjaan.vue?vue&type=style&index=0&id=072d7c04&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072d7c04"]])

export default __exports__